import * as React from 'react';
import styled from 'styled-components';

import { Condition } from '../../dashboard/enums/condition.enum';
import { fontWeights } from '../inline-styles/variables';

interface Props {
  value: string;
  color: string;
  condition: Condition;
}

interface StScoreDotProps {
  color: string;
  boxShadow: string;
}

const StScoreDot = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 88px;
  min-height: 88px;
  font-size: 2rem;
  font-weight: ${fontWeights.regular};
  color: #ffffff;
  border: 4px solid #ffffff;
  border-radius: 50%;
  box-sizing: border-box;
  background-color: ${(props: StScoreDotProps) => props.color};
  box-shadow: ${(props: StScoreDotProps) => props.boxShadow};
`;

class ScoreDot extends React.Component<Props> {
  render() {
    const { value, color, condition } = this.props;

    const boxShadow: string = condition !== Condition.Disconnected ? `0 0 10px 0 ${color}` : 'none';

    return (
      <StScoreDot color={color} boxShadow={boxShadow}>
        {value}
      </StScoreDot>
    );
  }
}

export default ScoreDot;



// WEBPACK FOOTER //
// ./src/app/ui/components/ScoreDot.tsx